<template>
  <v-container>
      
    <v-card>
      <v-card-title>
          <span>
          {{ $store.getters.faqIsEdit ? " ویرایش سوال متداول " : " ایجاد سوال متداول " }}
          </span>
          <v-spacer/><v-spacer/>
          
      </v-card-title>
      <v-divider/>
      <v-card-text>
        
        <v-form
           ref="form"
      v-model="validForm"
      lazy-validation
        >
          <v-row>
            <v-col cols="12" md="6"
              ><v-autocomplete
              required
                :rules="[
                  v => !!v || 'این فیلد الزامی است'
                ]"
                outlined
                dense
                chips
                small-chips
                :disabled="categoriesItems.disabled"
                clearable
                label="دسته بندی* "
                :items="categoriesItems"
                v-model="faqquestionsObject.faqCategoryId"
              ></v-autocomplete
            ></v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="faqquestionsObject.sortOrder"
                outlined
                dense
                label="ردیف"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
              required
                :rules="[
                  v => !!v || 'این فیلد الزامی است'
                ]"
                v-model="faqquestionsObject.question"
                outlined
                dense
                label="سوال مورد نظر*"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
              required
                :rules="[
                  v => !!v || 'این فیلد الزامی است'
                ]"
                v-model="faqquestionsObject.answer"
                outlined
                dense
                label="پاسخ *"
              ></v-textarea>
            </v-col>
           
            <v-col cols="12" md="6">
              <v-autocomplete
                hint="برای جستجو حداقل سه کاراکتر وارد کنید"
                persistent-hint
                :loading="pagesLoading"
                :search-input.sync="asyncGetPageItems"
                cache-items
                flat
                hide-no-data
                outlined
                dense
                chips
                small-chips
                clearable
                label="صفحه کمکی* "
                :items="pagesItems"
                v-model="faqquestionsObject.pageId"
              ></v-autocomplete
            ></v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
      <v-spacer/>
 <v-btn @click="closeForm" class="error ">انصراف</v-btn>
        <v-btn
          v-if="$store.getters.faqIsEdit"
          @click="editfaqquestions"
          class="primary "
          >ثبت ویرایش</v-btn
        >
        <v-btn v-else @click="createfaqquestions" class="primary ">ثبت</v-btn>
       

      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { RepoFactory } from "@/baseRepository/Factory";
const faqRepository = () => RepoFactory.get("faqPage");
const pageRepository = () => RepoFactory.get("pages");
const cfaqRepository = () => RepoFactory.get("categorizingFaqPage");

import Helper from "@/core/helpers";


export default {
  
  data() {
    return {
        validForm: true,
        asyncGetPageItems:"",
        pagesLoading:false,
        categoriesItems: [],
        pagesItems: [],
        faqquestionsObject: {
        question: "",
        answer: "",
        faqCategoryId: 0,
        pageId: null,
        sortOrder:null
      }
    };
  },
  created() {
    if (this.$store.getters.faqIsEdit) {
      const loader =this.$loading.show();
      faqRepository()
        .getDetailsFaqquestions(this.$store.getters.faqSelectedForEdit.id, this.baseUrl, {
          MerchantId : this.$store.getters.currentMerchant
        })
        .then(res => {
          this.faqquestionsObject = res.data;
          this.asyncGetPageItems=res.data.pageTitle;
          loader.hide()
        })
        .catch(error => {
          Helper.handleErrors(error, this);
          loader.hide()
        });
      }
      this.getcategoriesItems();
  },
  computed: {
    baseUrl() {
      return this.$store.getters.contentBaseUrl;
    }
  },
    watch: {
    asyncGetPageItems (val) {
        if (val && val.length >= 3 && val !== this.faqquestionsObject.pageId) {
        this.searchPage(val)
      }
    },
  },
  methods: {
 
    searchPage(val){
      const loader =this.$loading.show();
      if (val.length>=3) {
        this.pagesLoading = true;
        pageRepository()
        .getPagesWithFilter(this.baseUrl, {
          MerchantId : this.$store.getters.currentMerchant

        },{key:val})
        .then(res => {
            this.pagesLoading = false;
            this.pagesItems = res.data.map(item => {
                return {
                text: item.title,
                value: item.id
                };
            });
            loader.hide()
        })
        .catch(error => {
          Helper.handleErrors(error, this);
           this.pagesLoading = false;
           loader.hide()
        });
      }
    },
    getcategoriesItems() {
      this.categoriesItems = [];
      const loader =this.$loading.show();
      cfaqRepository()
        .getFaqcategoriesactiveListByPlatform(this.baseUrl, {
          MerchantId : this.$store.getters.currentMerchant
        })
        .then(res => {
          this.categoriesItems = res.data.map(item => {
            return {
              text: item.title,
              value: item.id,
              disabled :item.disabled
            };
          });
          loader.hide()
        })
        .catch(error => {
          Helper.handleErrors(error, this);
          loader.hide()
        });
    },
     closeForm() {
      this.$store.commit("setFaqSelectedForEdit", null);
      this.$store.commit("setFaqIsEdit", false);
      this.$store.commit("setFaqFormStatus", false);
      

    },
    createfaqquestions() {
        if(this.$refs.form.validate()){

      const loader =this.$loading.show();
        
      faqRepository()
        .createFaqquestions(this.faqquestionsObject, this.baseUrl, {
          MerchantId : this.$store.getters.currentMerchant
        })
        .then(res => {
          this.$dialog.message.success("با موفقیت ایجاد شد", {
            position: "top-left"
          });
          this.closeForm()
          loader.hide()
        })
        .catch(error => {
          Helper.handleErrors(error, this);
          loader.hide()
        });
        }
         else{
            this.$dialog.error({
          text: "وارد کردن موارد ستاره دار الزامی میباشد",
          title: "خطا",
          persistent: true,
          actions: [
            {
              text: "بستن",
              color: "red",
            },
          ],
        });
        }
    },
    
    editfaqquestions() {
       if(this.$refs.form.validate()){
       let body= {
          question: this.faqquestionsObject.question,
          answer: this.faqquestionsObject.answer,
          faqCategoryId: this.faqquestionsObject.faqCategoryId,
          pageId: this.faqquestionsObject.pageId,
          sortOrder: this.faqquestionsObject.sortOrder
        }
          const loader =this.$loading.show();
            this.faqquestionsObject.pageTitle = null;
          faqRepository()
            .updateFaqquestions(
              this.faqquestionsObject.id,
              body,
              this.baseUrl,
              {
                MerchantId : this.$store.getters.currentMerchant

              }
            )
            .then(res => {
              this.$dialog.message.success("با موفقیت ویرایش شد", {
                position: "top-left"
              });
              loader.hide()
              body.id = this.faqquestionsObject.id
            
              this.closeForm()
              // this.$store.commit("setFaqSelectedForEdit", body);
              // this.$store.commit("setFaqBackFromEditPage", true);

            })
            .catch(error => {
              Helper.handleErrors(error, this);
              loader.hide()
            });
        }
        else{
            this.$dialog.error({
          text: "وارد کردن موارد ستاره دار الزامی میباشد",
          title: "خطا",
          persistent: true,
          actions: [
            {
              text: "بستن",
              color: "red",
            },
          ],
        });
        }
      }
    }
  
};
</script>
